'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getPartnerConfig = getPartnerConfig;

var _media = require('utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_PARTNER_CONFIG = 'redux-frontend/app/GET_PARTNER_CONFIG';
var GET_PARTNER_CONFIG_SUCCESS = 'redux-frontend/app/GET_PARTNER_CONFIG_SUCCESS';
var GET_PARTNER_CONFIG_FAIL = 'redux-frontend/app/GET_PARTNER_CONFIG_FAIL';

var initialState = {
  isPartnerConfigLoaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GET_PARTNER_CONFIG:
      return (0, _extends3.default)({}, state, action.isLoaded ? { isPartnerConfigLoaded: true } : {});
    case GET_PARTNER_CONFIG_SUCCESS:
      var _action$result = action.result,
          found = _action$result.found,
          configData = (0, _objectWithoutProperties3.default)(_action$result, ['found']);

      var logos = {};
      if (found && configData.logos) {
        logos = (0, _extends3.default)({}, configData.logos.desktop ? { desktop: (0, _media.path)(configData.logos.desktop) } : {}, configData.logos.desktop2x ? { desktop2x: (0, _media.path)(configData.logos.desktop2x) } : {}, configData.logos.mobile ? { mobile: (0, _media.path)(configData.logos.mobile) } : {}, configData.logos.mobile2x ? { mobile2x: (0, _media.path)(configData.logos.mobile2x) } : {}, configData.logos.alt ? { alt: configData.logos.alt } : {});
      }
      return (0, _extends3.default)({}, state, {
        isPartnerConfigLoaded: true,
        isPartner: found,
        affId: action.affId
      }, found ? { partnerConfig: (0, _extends3.default)({}, configData, { logos: logos, theme: {} }) } : {});
    case GET_PARTNER_CONFIG_FAIL:
      return (0, _extends3.default)({}, state, {
        isPartnerConfigLoaded: true
      });
    default:
      return state;
  }
}

function getPartnerConfig(referenceId) {
  if (!referenceId) {
    return {
      type: GET_PARTNER_CONFIG,
      isLoaded: true
    };
  }

  return {
    types: [GET_PARTNER_CONFIG, GET_PARTNER_CONFIG_SUCCESS, GET_PARTNER_CONFIG_FAIL],
    promise: function promise(client) {
      return client.get('/affiliate/config/' + referenceId);
    },
    affId: referenceId
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/app.js
// module id = 680
// module chunks = 47